import { type UndecoratedProfile } from '@flemingmetrics/api-client';
import Avatar, { type AvatarProps } from '@/components/Avatar';
import { getAvatarUrl } from '@/api/getUrl';
import { getProfileLabels } from './utils';

export interface ProfilePictureProps extends AvatarProps {
  profile: UndecoratedProfile;
}

export default function ProfilePicture({
  loading,
  className,
  profile,
  ...props
}: ProfilePictureProps) {
  const labels = getProfileLabels(profile);
  return (
    <Avatar
      className={className}
      loading={loading}
      src={profile.avatarUrl && getAvatarUrl(profile)}
      label={labels.initials}
      alt={labels.name}
      {...props}
    />
  );
}
